import { Component, EventEmitter, HostListener, Input, Output, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { ConfirmDialogAlertMessage } from '../../../../Common/Dialogs/models/confirm-dialog-alert-message.model';


@Component({
    selector: 'agpr-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent extends AbstractDialogComponent {

    @Input() id: string;
    @Input() heading: string;
    @Input() alertMessage: string;
    @Input() alertMessages: ConfirmDialogAlertMessage[];
    @Input() alertType: messageSeverityEnum;
    @Input() message: string;
    @Input() messageHtml: string;
    @Input() contentTemplate: TemplateRef<any>;

    @Input() allowEmptyList: boolean = false; // If true, the dialog will allow the user to confirm even if the list and/or secondaryList is empty.
    @Input() list: string[];
    @Input() listLabel: string;
    @Input() isListSelected: boolean = true;

    @Input() secondaryList: string[];
    @Input() secondaryListLabel: string;
    @Input() isSecondaryListSelected: boolean = false;

    @Input() bottomMessage: string;
    @Input() alertMessageList: string[];
    @Input() width: number;
    @Input() maxWidth: number;
    @Input() disclaimerText: string;

    @Input() okLabel: string = 'Core.button.ok';
    @Input() okLabelLeft: boolean = false;
    @Input() cancelLabel: string = 'Core.button.cancel';
    @Input() showCancel: boolean = true;
    @Input() bottomMargin: boolean = false;
    @Input() closeOnClickOutside: boolean = true;

    @Input() confirmAction: () => Observable<any>;
    @Input() style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;
    @Input() alertBelowMessage: boolean = false;

    @Output() listSelectionChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() secondaryListSelectionChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    loading: boolean = false;
    disclaimerAccepted: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;
    readonly componentStyle = AgprComponentStyleEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'Confirm');
        this.alertType = messageSeverityEnum.info;
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        this.cancel();
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        if (this.confirmAction) {
            this.loading = true;
            this.confirmAction().subscribe({
                next: () => this.closeDialog(),
                error: () => this.loading = false
            });
            return;
        }

        this.closeDialog(true);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }
}
